<template>
    <div class="g-seven-edit">{{visiableDialog}}
        <el-dialog
            class="g-seven-edit-dialog"
            title="传化"
            :close-on-click-modal="false"
            width="90%"
            :visible.sync="visiableDialog"
            :before-close="handleClose">
            <form-dialog ref="formDialog" :inline="true" :fieldList="fieldList" :rules="rules" :data="data"
            @getAddress="getAddress">
            </form-dialog>
            <div slot="footer" class="dialog-footer">
                <el-button class="dialog-btn" @click="handleClose">取 消</el-button>
                <el-button class="dialog-cel" type="primary" @click="saveOk">保 存</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import FormDialog from '../../components/formDialog/Main';
import { getUpdateLists } from '../../../../api/vehicleFreePlatform';
export default {
    components: { FormDialog },
    props: {
        visiableDialog: {
            type: Boolean,
            default: false
        },
        labelPosition: {
            type: String,
            default: 'right'
        },
        data: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        const allFreightValida = (rule, value, callback) => {
            if (value !== '' && value !== undefined) {
                const reg = /^\d{0,7}(\.\d{0,2})?$/;
                if (reg.test(value)) {
                    return callback();
                } else {
                    return callback(new Error('不能大于2位小数，不能超百万'));
                }
            }
        };
        const senderAddrValida = (rule, value, callback) => {
            if (!value || value.length <= 0) {
                return callback(new Error('发货地址不能为空'));
            } else {
                return callback();
            }
        };
        const receiverAddrValida = (rule, value, callback) => {
            if (!value || value.length <= 0) {
                return callback(new Error('收货地址不能为空'));
            } else {
                return callback();
            }
        };
        return {
            ruleForm: {
                dispatchNo: ''
            },
            rules: {
                dispatchNo: [
                    { required: true, message: '发车单号不能为空' }
                ],
                allFreight: [
                    { required: true, message: '运输成本不能为空' },
                    { message: '不能大于2位小数，不能超百万', validator: allFreightValida }
                ],
                siteCode: [
                    { required: true, message: '发车平台不能为空' }
                ],
                senderAddr: [
                    { required: true, validator: senderAddrValida }
                ],
                receiverAddr: [
                    { required: true, validator: receiverAddrValida }
                ],
                senderDetailAddr: [
                    { required: true, message: '发货详细地址不能为空' }
                ],
                receiverDetailAddr: [
                    { required: true, message: '收货详细地址不能为空' }
                ],
                receiver: [
                    { required: true, message: '收货人不能为空' }
                ],
                receiverContactWay: [
                    { required: true, message: '收货人电话不能为空' }
                ],
                driver: [
                    { required: true, message: '司机不能为空' }
                ],
                driverContactWay: [
                    { required: true, message: '司机电话不能为空' }
                ],
                vehicleCard: [
                    { required: true, message: '车牌不能为空' }
                ],
                driverCard: [
                    { required: true, message: '身份证号不能为空' }
                ]
            },
            fieldList: [
                { label: '发车单号', prop: 'dispatchNo', type: 'input', disabled: true },
                {
                    label: '发车平台',
                    prop: 'siteName',
                    type: 'siteAdvance',
                    params: {
                        'value': 'siteName',
                        'type': 'advance',
                        'unfold': true,
                        'advanceConfig': [
                            { 'prop': 'escoCompanyNameCn', 'value': '服务平台名称' },
                            { 'prop': 'escoCompanyNo', 'value': '服务平台编码' }
                        ],
                        'tableConfig': [
                            { 'prop': 'escoCompanyNameCn', 'value': '服务平台名称' },
                            { 'prop': 'escoCompanyNo', 'value': '服务平台编码' }
                        ],
                        'advanceUrl': '/searchPlatform',
                        'cbParams': ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName'],
                        'advanceCode': 'advanceCode'
                    }
                },
                { label: '发货地址', prop: 'senderAddr', type: 'addressSelect', minLayers: 3 },
                { label: '发货详细地址', prop: 'senderDetailAddr', type: 'input' },
                { label: '收货地址', prop: 'receiverAddr', type: 'addressSelect', minLayers: 3 },
                { label: '收货详细地址', prop: 'receiverDetailAddr', type: 'input' },
                { label: '收货人', prop: 'receiver', type: 'input' },
                { label: '收货人电话', prop: 'receiverContactWay', type: 'input' },
                {
                    label: '司机',
                    prop: 'driver',
                    type: 'driverAdvance',
                    params: {
                        'name': '请输入司机',
                        'advanceLabel': '司机',
                        'value': 'driver',
                        'advanceConfig': [
                            { 'prop': 'name', 'value': '司机' },
                            { 'prop': 'encuMobile', 'value': '电话' }

                        ],
                        'tableConfig': [
                            { 'prop': 'name', 'value': '司机' },
                            { 'prop': 'encuMobile', 'value': '电话' }
                        ],
                        'advanceUrl': 'suDriver/searchByConditions',
                        'cbParams': [
                            'name#driver', 'encuMobile#driverContactWay', 'cardId#driverIdentity', 'suppliersCode'
                        ],
                        'advanceCascade': 'carrierCode#suppliersCode'
                    }
                },
                { label: '司机电话', prop: 'driverContactWay', type: 'input', disabled: true },
                { label: '车牌', prop: 'vehicleCard', type: 'input' },
                { label: '身份证号', prop: 'driverCard', type: 'input', disabled: true },
                { label: '运输成本', prop: 'allFreight', type: 'input' }
            ]
        };
    },
    methods: {
        handleClose() {
            this.$emit('handleClose', '');
        },
        saveOk() {
            this.$refs.formDialog.$refs.formDialog.validate(valid => {
                if (valid) {
                    const params = this.$refs.formDialog.formData;
                    getUpdateLists(params).then(res => {
                        if (res) {
                            this.$message.success('编辑成功');
                            this.$emit('saveOk', true);
                        }
                    });
                }
            });
        },
        dialogMousedown() {},
        getAddress(labels, item) {
            const formData = this.$refs.formDialog.formData;
            if (item.prop === 'senderAddr') {
                if (labels && labels.length > 0) {
                    ['senderProvinceName', 'senderCityName', 'senderDistrictName'].forEach((key, index) => {
                        formData[key] = labels[index] || '';
                    });
                    ['senderProvinceCode', 'senderCityCode', 'senderDistrictCode'].forEach((key, index) => {
                        formData[key] = formData['senderAddr'][index] || '';
                    });
                }
            } else if (item.prop === 'receiverAddr') {
                if (labels && labels.length > 0) {
                    ['receiverProvinceName', 'receiverCityName', 'receiverDistrictName'].forEach((key, index) => {
                        formData[key] = labels[index] || '';
                    });
                    ['receiverProvinceCode', 'receiverCityCode', 'receiverDistrictCode'].forEach((key, index) => {
                        formData[key] = formData['receiverAddr'][index] || '';
                    });
                }
            }
        }
    }
};
</script>

<style lang="less">

</style>